"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const DOMStorage_1 = require("../Utilities/DOMStorage");
const jsonapi_1 = require("../HttpClient/jsonapi");
const reloginFacebookKey = "MBaaS.auth.reloginFacebook";
const reloginGoogleKey = "MBaaS.auth.reloginGoogle";
class Auth {
    constructor(client) {
        this._encryption = false;
        this._jsonApiClient = client._jsonApiClient;
        this._baseUrl = client.applicationUrl + "/services/auth";
        this._accountUrl = client.applicationUrl + "/services/auth/account";
        this._verificationUrl =
            client.applicationUrl + "/services/emailverification";
        const encryptionOptions = client.options.payloadEncryption;
        if (encryptionOptions && encryptionOptions.enforcement.includes("COMMON")) {
            this._encryption = true;
        }
    }
    checkEmail(email) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._jsonApiClient.request("GET", this._accountUrl, {
                    params: { email },
                    auth: false,
                    encryption: this._encryption,
                });
                return (0, jsonapi_1.deserialize)(res.data, {
                    keyForAttribute: "snake_case",
                    extras: { message: res.data.meta.message },
                });
            }
            catch (err) {
                return { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
        });
    }
    register(provider, data) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._jsonApiClient.request("POST", this._accountUrl, {
                    data: { provider, data },
                    auth: false,
                    encryption: this._encryption,
                });
                return (0, jsonapi_1.deserialize)(res.data, {
                    keyForAttribute: "snake_case",
                    extras: { message: res.data.meta.message },
                });
            }
            catch (err) {
                return { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
        });
    }
    resendVerification(email) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._jsonApiClient.request("POST", this._verificationUrl, {
                    data: { email },
                    auth: false,
                    encryption: this._encryption,
                });
                return res.data.meta;
            }
            catch (err) {
                return { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
        });
    }
    oauthRedirect(provider, callback) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { sessionStorage } = (0, DOMStorage_1.DOMStorage)();
            try {
                const res = yield this._jsonApiClient.request("GET", this._baseUrl, {
                    params: { provider, callback },
                    auth: false,
                    encryption: this._encryption,
                });
                const resData = res.data.data;
                if (resData.type === "OAuthLink") {
                    if (provider === "facebook")
                        sessionStorage.setItem(reloginFacebookKey, resData.attributes.url);
                    if (provider === "google")
                        sessionStorage.setItem(reloginGoogleKey, resData.attributes.url);
                    if (typeof window === "object" && window.location) {
                        window.location.assign(resData.attributes.url);
                        return null;
                    }
                    return (0, jsonapi_1.deserialize)(res.data);
                }
            }
            catch (err) {
                return { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
        });
    }
    redoOAuth(provider) {
        const { sessionStorage } = (0, DOMStorage_1.DOMStorage)();
        let reloginUrl;
        if (provider === "facebook") {
            reloginUrl = sessionStorage.getItem(reloginFacebookKey);
            sessionStorage.removeItem(reloginFacebookKey);
        }
        if (provider === "google") {
            reloginUrl = sessionStorage.getItem(reloginGoogleKey);
            sessionStorage.removeItem(reloginGoogleKey);
        }
        if (reloginUrl) {
            if (typeof window === "object" && window.location) {
                window.location.assign(reloginUrl);
                return null;
            }
            return { reloginUrl, provider };
        }
    }
    login(provider, data, intent = "register") {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!["register", "link"].includes(intent))
                return {
                    error: {
                        name: "ValidationError",
                        message: "'intent' value is not allowed",
                    },
                };
            try {
                const res = yield this._jsonApiClient.request("POST", this._baseUrl, {
                    data: { provider, data },
                    auth: false,
                    encryption: this._encryption,
                });
                const resData = res.data.data;
                if (resData.type === "LoginExisting") {
                    if (intent === "link")
                        return {
                            error: {
                                name: "ForbiddenError",
                                message: "Social account already in use",
                            },
                        };
                    this._jsonApiClient.saveTokenset({
                        rt: resData.attributes.refreshToken,
                        at: resData.attributes.accessToken,
                        exp: resData.attributes.expiry,
                    });
                    delete resData.attributes.refreshToken;
                    delete resData.attributes.accessToken;
                    delete resData.attributes.expiry;
                }
                return (0, jsonapi_1.deserialize)(res.data, {
                    extras: {
                        type: res.data.data.type,
                        message: res.data.meta.message,
                    },
                });
            }
            catch (err) {
                return { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
        });
    }
    forgotPassword(email) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this._jsonApiClient.request("DELETE", this._baseUrl, {
                    params: { email },
                    auth: false,
                    encryption: this._encryption,
                });
                return null;
            }
            catch (err) {
                return { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
        });
    }
    resetPassword(token, password) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this._jsonApiClient.request("PUT", this._baseUrl, {
                    data: { token, password },
                    auth: false,
                    encryption: this._encryption,
                });
                return (0, jsonapi_1.deserialize)(res.data, {
                    keyForAttribute: "snake_case",
                    extras: { message: res.data.meta.message },
                });
            }
            catch (err) {
                return { error: (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b[0] };
            }
        });
    }
}
exports.default = Auth;
